export default __webpack_public_path__ + "static/text-logo-c95974b9c6d43135ef2529a462862508.svg";